exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "canvas{position:fixed;top:0;left:0;z-index:-1}.container-winners{overflow:hidden;margin-top:40px}.image-cartel{position:relative;margin-top:20px!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-75f6778c","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?indentedSyntax!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/BaseWinnersConcurse.vue
// module id = OgXS
// module chunks = 0